<template>
  <products :productData="productData"></products>
</template>

<script>
import Products from '../components/additional/ProductList.vue'

export default {
  components: {
    Products,
  },
  data () {
    return { 
      productData: {
        title: "事前注文",
        returnBack: '/admin/pre_product_list/',
        editUrl: '/admin/pre_product/edit/',
        apiUrl: '/pre_order_products/'
      }}
  }
}
</script>